import { render, staticRenderFns } from "./confirmMultipleEdit.vue?vue&type=template&id=966d304c&lang=pug"
import script from "./confirmMultipleEdit.vue?vue&type=script&lang=js"
export * from "./confirmMultipleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports